declare global {
    interface Window {
        vueConfigProvider: any;
    }
}

export default {
    get(key: string, defaultValue?: any) {
        const vueConfigProvider = window.vueConfigProvider
        const value = vueConfigProvider[key]
        if (value !== undefined) {
            return value
        }
        return defaultValue
    }
}
